import MenuItem from './menu_item/MenuItem'

let cssPromise = import('./sidebar.scss')


export default function Sidebar(opts={}){
    
    BaseConstructor.call(this)
    let {container,position = 'left', menu_items=[], map, open} = opts
    let elements = {}
    let context = this
    let offcanvasComponent

    let currentShowing = null
    let isOpen = false

    this.show = () =>{
        $(elements.container).addClass('show')
        isOpen = true
    }

    this.hide = () =>{
        $(elements.container).removeClass('show')
        isOpen = false
    }

    this.toggleVisibility = () =>{
        $(elements.container).toggleClass('show')
    }

    init()
    
    function init(){
        elements.container = context.createElement('div', 'sidebar-container')

        $(elements.container).css({
            position: IS_MOBILE ? 'absolute' : 'relative'
        })
        // elements.container.style.width = '0px'
        elements.content_wrapper = context.createElement('div', 'content-wrapper')
        elements.content_container = context.createElement('div', 'content-container pretty-scrollbar')

        $(elements.content_wrapper).append(elements.content_container)

        elements.items_container = context.createElement('div', 'sidebar-menuitems')

        $(elements.container).append(elements.items_container, elements.content_wrapper)

    	if(position == 'left'){
            $(container).prepend(elements.container)
        } else {
            $(container).append(elements.container)
        }

        menu_items.forEach(menu_item=>{

            $(elements.content_container).append(`<div data-id="${menu_item.id}" class="content ${menu_item.id}">${menu_item.content || ''}</div>`)

            let menuItem = new MenuItem({id: menu_item.id, title:menu_item.title, closeIcon: menu_item.closeIcon, icon: menu_item.icon})
            menu_item.menuItem = menuItem
            menuItem.on('click', id=>{
                if(isOpen){
                    currentShowing.menuItem.disable()
                    $(elements.content_container).find('[data-id="'+currentShowing.id+'"]').removeClass('show') 
                    if(currentShowing.id === id){
                        context.hide()
                        currentShowing = null
                    } else {
                        
                        currentShowing = menu_item
                    }
                } else {
                    context.show()
                    currentShowing = menu_item
                } 
                if(currentShowing){
                    currentShowing.menuItem.active()
                    context.trigger('show-content', currentShowing)
                    $(elements.content_container).find('[data-id="'+menu_item.id+'"]').addClass('show') 
                }

                map.invalidateSize()
            })

            $(elements.items_container).append(menuItem.getElement())
        })
        
        

        cssPromise.then(_=>{
            setTimeout(_=>{
                let max_h = [...elements.items_container.childNodes].map(x=>x.offsetHeight).reduce((a,c)=> a > c ? a : c)
                let max_w = [...elements.items_container.childNodes].map(x=>x.offsetWidth).reduce((a,c)=> a > c ? a : c)
                elements.items_container.childNodes.forEach(node=>{
                    $(node).css({'min-height': max_h + 'px', 'min-width': max_w + 'px'})
                })
                if(open){
                    menu_items[0].menuItem.trigger('click')
                }
                
            },500)

            
        })

        
        

    }
}

Sidebar.prototype = Object.create(BaseConstructor.prototype)